import { SHARED_NAMESPACE } from '@/store/shared'

import { partyName } from '@/utilities'

import { AddressesGetters } from './partials/addresses'
import { EmailsGetters } from './partials/emails'
import { PartyEditGetters } from './partials/party-edit'
import { PartyMergeGetters } from './partials/party-merge'
import { PartySurveysPageGetters } from './partials/party-surveys-page'
import { PartyTagGetters } from './partials/party-tag'
import { PhonesGetters } from './partials/phones'
import { ResidenceHistoriesGetters } from './partials/residence-histories'

export const PartyGetters = {
  ...AddressesGetters,
  ...EmailsGetters,
  ...PartyEditGetters,
  ...PartyMergeGetters,
  ...PartyTagGetters,
  ...PhonesGetters,
  ...ResidenceHistoriesGetters,
  ...PartySurveysPageGetters,
  currentParty: state => state.currentParty,
  isLoading: state => state.isSearching,
  parties: state => state.parties,
  unassociatedParties: (_, __, ___, rootGetters) => _ => {
    return rootGetters[`${SHARED_NAMESPACE}/getCachedDropdown`]('parties')?.map(party => ({
      text: `${partyName(party)} (${party.dob}) (ID: ${party.id})`,
      value: party.id,
      ...party,
    })) || []
  },
}
